import { useCallback, useMemo, useState } from "react";

import { getPlannerVisibleTasks } from "../utils/myTaskUtils";

export function usePlannerTaskPanelState(filteredTasks = []) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const visibleTasks = useMemo(
    () => getPlannerVisibleTasks(filteredTasks, inputValue),
    [filteredTasks, inputValue]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  return {
    anchorEl,
    inputValue,
    visibleTasks,
    handleClose,
    handleOpen,
    setInputValue,
  };
}
